/*
 *
 * ----------------------------------------------- */

$(window).on("load resize", function () {
  var $sectionService = $(".section-service");
  if ($sectionService) {
    var windowWidth = $(window).width();
    var scrollPos = 0;

    var wrap = $(".section-service");
    var elWrap = $(".section-service .horizontal-container");

    var horLength = elWrap.width();
    var distFromTop = wrap.offset().top;

    var scrollDistance = distFromTop + horLength - windowWidth;

    wrap.css("height", horLength);
    $(document).scroll(function () {
      scrollPos = $(this).scrollTop();

      if (scrollPos >= distFromTop && scrollPos <= scrollDistance) {
        var valueOffset = -(scrollPos - distFromTop);
        elWrap.css("transform", `translate3d(${valueOffset}px, 0px, 0px)`);
      }
    });
  }
});
